
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aussteller/[slug]",
      function () {
        return require("private-next-pages/aussteller/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aussteller/[slug]"])
      });
    }
  